import script from "./Step4Applicant.vue?vue&type=script&setup=true&lang=js"
export * from "./Step4Applicant.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__